import type { Plan, RecurringPeriod } from './types';

export const getPlanSkus = (plans: Plan[], recurringPeriod?: RecurringPeriod): string[] => {
  if (!recurringPeriod) {
    return plans.flatMap((plan) => [plan.pricing.monthly.sku, plan.pricing.yearly.sku]);
  }

  return plans.map((plan) => plan.pricing[recurringPeriod].sku);
};
